/* eslint-disable global-require */
/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 *
 * To add a new locale
 *   - Establish the name of your [locale] (see below)
 *   - Add '[locale]' to `localesList` array
 *   - Import [locale] from @formatjs
 *          require('@formatjs/intl-relativetimeformat/locale-data/[locale]');
 *   - Import & add [antd-locale] to the `antdLocales` variable
 *          antdLocales[[locale]] = require('antd/lib/locale-provider/[antd-locale]').default;
 *   - Import [moment-locale]
 *          require('moment/locale/[moment-locale]');`
 *   - Create a file for the translation messages: `app/translations/[locale].json`
 *      Initialize content with `[]`
 *   - Import & Add translation messages in the `translationMessages` variable
 *          translationMessages[[locale]] = require('./translations/[locale].json');
 *
 *  Notes:
 *  * [locale]: see `@formatjs/intl-relativetimeformat/locale-data/` for the list of locales
 *  * Note that if language === region (i.e. fr-FR) then the locale usually is only the language (fr)
 *  * [antd-locale]: see `antd/lib/locale-provider/` for locale names
 *  * [moment-locale]: see `moment/locale/` for locale names
 *  * You must import the momentJS locale, but you don't need to set the locale
 *      Antd takes care of setting the locale in moment when changed in the provider
 */

if (!Intl.PluralRules) {
    require('intl-pluralrules');
}

if (!Intl.RelativeTimeFormat) {
    require('@formatjs/intl-relativetimeformat/polyfill');
}
/**
 *
 * List of locales supported in the app
 *
 *
 * Values are `react-intl` locale tags
 * (tags may differ for antd and moment)
 */

// prettier-ignore
const localesList = [
    'en-GB',
];

const antdLocales = {}; // AntDesign locale data object per locale
const translationMessages = {}; // Translation messages per locale

// Load locales for react-intl, antd and moment (antd uses momentJS dates)

/* EN (GB) */
require('@formatjs/intl-relativetimeformat/locale-data/en-GB');
antdLocales['en-GB'] = require('antd/locale/en_GB').default;
require('moment/locale/en-gb');

// Load translation messages
translationMessages['en-GB'] = require('./translations/en-GB.json');

const DEFAULT_LOCALE = 'en-GB';

const formatTranslationMessages = (locale, messages) => {
    // prettier-ignore
    const defaultFormattedMessages =
        locale !== DEFAULT_LOCALE
            ? formatTranslationMessages(DEFAULT_LOCALE, translationMessages[DEFAULT_LOCALE])
            : {};
    const flattenFormattedMessages = (formattedMessages, key) => {
        const formattedMessage =
            !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];
        return Object.assign(formattedMessages, { [key]: formattedMessage });
    };
    return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

// Merge all locales into 1 object, with translation messages & antd locales
const appLocales = localesList.reduce(
    (acc, locale) => ({
        ...acc,
        [locale]: {
            messages: translationMessages[locale],
            antd: antdLocales[locale],
        },
    }),
    {},
);

// exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
// exports.appLocales = appLocales;
// exports.localesList = localesList;
// exports.formatTranslationMessages = formatTranslationMessages;

export { DEFAULT_LOCALE, appLocales, localesList, formatTranslationMessages };
